export default "__VITE_PUBLIC_ASSET__dc2caa15__"